import i18n from '../../../../locales/index'
import User from './user.vue'
export default User
